export const SORT_PARAM = 'sort';
